import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { WidthFull } from '@mui/icons-material';

const LoadingSpinner = ({ 
  message = 'Loading...', 
  size = 40,
  fullScreen = true,
  color = 'primary' 
}) => {
  const containerStyle = fullScreen ? {
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    gap: 2
  } : {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 4,
    gap: 2
  };

  return (
    <Box sx={containerStyle}>
      <CircularProgress size={size} color={color} />
      {message && (
        <Typography variant="body1" color="textSecondary">
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingSpinner;
